import { z } from 'zod';

/**
 * Stripe.confirmPayment redirect params.
 * Used to verify payment method update after Stripe redirect.
 */
const EditPaymentMethodResponse = z.object({
  /** Custom property set by us in the Stripe return url */
  subscription_id: z.string().optional(),
  /** Stripe Setup Intent id */
  setup_intent: z.string().optional(),
  /** Stripe Client Secret */
  client_secret: z.string().optional(),
  /** Stripe redirect status */
  redirect_status: z
    .enum(['success', 'succeeded', 'failure', 'failed'])
    .optional(),
  /** Stripe setup intent client secret */
  setup_intent_client_secret: z.string(),
});

/**
 * Used to trigger an access denied toast when the user is trying
 * to access a page they don't have access to.
 */
const AccessDenied = z.object({
  access_denied: z.string(),
});

export const SearchParamSchemas = {
  EditPaymentMethodResponse,
  AccessDenied,
};
